export default {
  token(state, token) {
    state.token = token;
  },
	CLIENT(state, client) {
		state.client = client;
  },
  UPDATE_LOADING (state, status) {
    state.isLoading = status
  },
  UPDATE_DIRECTION (state, direction) {
    state.direction = direction
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js